import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77ad5eeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-ct" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { refusedBillApi } from '@/apis/fund'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { isMultiStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['type'],
  emits: ['submit'],
  setup(__props, { expose, emit }) {

const props = __props

const store = useStore()
const isSub = store.getters.isSub
const item = ref({})
const visible = ref(false)
const loading = ref(false)
const customerRefusedReason = ref('')

const open = (record: any) => {
  console.log(record)
  item.value = record
  console.log(item)
  visible.value = true
}
const close = () => {
  customerRefusedReason.value = ''
  visible.value = false
}
const submit = () => {
  emit('submit', item.value)
  close()
}
expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    "custom-class": "a-detail-p flex",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('提示2')), 1),
      (item.value?.currencyCode === 'KRW' && _unref(isMultiStore)())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "detail-refuse",
            innerHTML: _unref(t)('点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX韩元，确定支付吗').replace('XX', item.value.billAmount)
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "detail-refuse",
            innerHTML: _unref(t)('点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX元，确定支付吗').replace('XX', item.value.billAmount)
          }, null, 8, _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "default",
          onClick: close,
          class: "btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          class: "btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})